import template from "./count_variances.html";
import controller from "./count_variances.controller";
import "./count_variances.scss";

let branchManagementCountVariancesComponent ={
    restrict: "E",
    bindings: {},
    template,
    controller
}

export default branchManagementCountVariancesComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/count_variances/count_variances.component.js